import Vue from 'vue';
import on from 'dom-event';
import debounce from 'lodash.debounce';
import { isTablet } from 'utils/general';
import { Pagination, A11y, Keyboard } from 'swiper/modules';

export default (el) =>
  new Vue({
    components: {
      'vue-image': () => import('../vue-image/vue-image.vue'),
      'vue-swiper':  () => import('../vue-swiper/vue-swiper.vue'),
      'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
    },
    el,
    data: () => ({
      swiperOptions: {
        slidesPerView: 2,
        spaceBetween: 20,
        centeredSlides: true,
        loop: true,
        grabCursor: true,
        a11y: true,
        keyboard: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          enabled: true,
          renderBullet: function (index, className) {
            return `<button class="${className}"></button>`;
          },
        },
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 35,
            pagination: {
              enabled: false
            }
          }
        },
        modules: [Pagination, A11y, Keyboard]
      }
    }),
    mounted() {
    },
    computed: {
    },
    methods: {
    },
  });
